import React from "react";
import { motion } from "framer-motion";

export function PrimaryButton({
    label = "Let's Make It Move",
    onClick,
    className = "",
    "data-testid": testId,
    ...rest
}) {
    return (
        <motion.button
            type="button"
            onClick={onClick}
            data-testid={testId}
            whileHover={{ y: -2 }}
            transition={{ duration: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
            className={`group relative inline-flex items-center justify-center rounded-full border-2 px-8 py-3 sm:px-10 sm:py-3.5 md:px-12 md:py-4 text-base sm:text-base md:text-base font-medium uppercase tracking-[0.22em] backdrop-blur-md transition-colors ${className}`}
            style={{
                color: "var(--text)",
                borderColor: "var(--line)",
                background: "rgba(255,255,255,0.04)",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "var(--accent)";
                e.currentTarget.style.boxShadow = "0 0 24px var(--accent-soft), 0 0 60px var(--accent-soft)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "var(--line)";
                e.currentTarget.style.boxShadow = "none";
            }}
            {...rest}
        >
            <span className="relative z-10">{label}</span>
            <span
                className="absolute right-5 sm:right-6 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                style={{ background: "var(--accent)", boxShadow: "0 0 10px var(--accent-soft)" }}
            />
        </motion.button>
    );
}

export function GhostButton({
    label = "View Case",
    onClick,
    className = "",
    "data-testid": testId,
    ...rest
}) {
    return (
        <motion.button
            type="button"
            onClick={onClick}
            data-testid={testId}
            whileHover={{ y: -1 }}
            transition={{ duration: 0.25, ease: [0.25, 0.1, 0.25, 1] }}
            className={`inline-flex items-center justify-center rounded-full border-2 px-6 py-2.5 sm:px-8 sm:py-3 text-base sm:text-base font-medium uppercase tracking-[0.22em] transition-colors hover:bg-white/5 ${className}`}
            style={{
                color: "var(--text)",
                borderColor: "var(--line)",
                background: "transparent",
            }}
            {...rest}
        >
            {label}
        </motion.button>
    );
}
